import { ActionModal, colors } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTriggerRenewalsPageStore } from 'store/pages/tools/trigger-renewals/pageStore';
import { ModalNotesStyled, ReloadIconStyled } from '../WarningModals/styles';

const MoveToRenewalModal: React.FC = observer(() => {
  const {
    renewalGroupActionDelegate: { moveToRenewalModalDelegate },
  } = useTriggerRenewalsPageStore();
  const { isVisible, isLoading, close, confirm } = moveToRenewalModalDelegate;

  return (
    <ActionModal
      show={isVisible}
      loading={isLoading}
      onClose={close}
      onAction={confirm}
      title="Please Confirm an Action"
      subtitle={
        <ModalNotesStyled>
          <span>You are about to move the current period to renewal.</span>
        </ModalNotesStyled>
      }
      actionButtonText="Move to Renewal"
      icon={<ReloadIconStyled width="5.6rem" color={colors.green[600]} />}
    />
  );
});

export default MoveToRenewalModal;
